import Service from './baseService';
import { getModelTypeIdAndEntityId } from '../config';

export const getTourRouteVehicleAssignments = (tourRouteID) => {
    return Service.get(`/tourRoutes/vehicleAssignments/${tourRouteID}`, {
        params: { ...getModelTypeIdAndEntityId() },
    });
};

export const createTicketsService = (payload) => {
    return Service.post(`/tourRoutes/tickets/`, payload);
};

export const getTourTicketInfoSettingsService = (vehicleAssignmentID) => {
    return Service.get(`/tourRoutes/tourTicketInfoSettings`, {
        params: { vehicleAssignmentID, ...getModelTypeIdAndEntityId() },
    });
};

export const getTourVehicleAssignmentDiscountCodesService = (vehicleAssignmentID) => {
    return Service.get(`/tourRoutes/vehicleAssignments/discount-code`, {
        params: { vehicleAssignmentId: vehicleAssignmentID, ...getModelTypeIdAndEntityId() },
    });
};

export const applyTourDiscountCodeService = (data) => {
    return Service.get(`/tourRoutes/vehicleAssignments/apply-discount-code`, {
        params: { ...data, ...getModelTypeIdAndEntityId() },
    });
};
